import { NewApiBaseUrl } from '../consts/new-api-base-url'

const apiBase = () => String(NewApiBaseUrl).replace(/\/$/, '')

export const PACKAGE_EXPORTS_PATH = '/Crash/package-exports'

/**
 * @returns {string}
 */
export function getPackageExportsListUrl() {
  return `${apiBase()}${PACKAGE_EXPORTS_PATH}`
}

/**
 * @param {string} packageId
 * @returns {string}
 */
export function getPackageExportDetailUrl(packageId) {
  return `${apiBase()}${PACKAGE_EXPORTS_PATH}/${encodeURIComponent(packageId)}`
}

/**
 * @param {string} packageId
 * @returns {string}
 */
export function getPackageExportCrashesUrl(packageId) {
  return `${apiBase()}${PACKAGE_EXPORTS_PATH}/${encodeURIComponent(packageId)}/crashes`
}

/**
 * @param {string} accidentId
 * @returns {string}
 */
export function getPackageExportByAccidentUrl(accidentId) {
  return `${apiBase()}${PACKAGE_EXPORTS_PATH}/${encodeURIComponent(accidentId)}`
}

/**
 * @param {Response} res
 * @returns {Promise<{ status: number, body: unknown }>}
 */
async function parseJsonResponse(res) {
  const text = await res.text()
  let body = null
  if (text) {
    try {
      body = JSON.parse(text)
    } catch {
      body = { raw: text }
    }
  }
  return { status: res.status, body }
}

/**
 * GET lista paginata.
 *
 * @param {string} bearerToken
 * @param {Object} [options]
 * @param {number} [options.organizationId]
 * @param {number} [options.limit=50]
 * @param {number} [options.offset=0]
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function listCrashPackageExports(
  bearerToken,
  { organizationId, limit = 50, offset = 0 } = {},
) {
  const url = new URL(getPackageExportsListUrl())
  if (organizationId != null) {
    url.searchParams.set('organization_id', String(organizationId))
  }
  url.searchParams.set('limit', String(limit))
  url.searchParams.set('offset', String(offset))

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      Accept: 'application/json',
    },
  })

  return parseJsonResponse(res)
}

/**
 * @param {Object} params
 * @param {string} params.bearerToken
 * @param {number} [params.page=0]
 * @param {number} [params.pageSize=25]
 * @param {number} [params.organizationId]
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function fetchPackageExportsList({
  bearerToken,
  page = 0,
  pageSize = 25,
  organizationId,
}) {
  return listCrashPackageExports(bearerToken, {
    organizationId,
    limit: pageSize,
    offset: page * pageSize,
  })
}

/**
 * GET dettaglio per packageId (UUID manifest).
 *
 * @param {string} packageId
 * @param {string} bearerToken
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function getCrashPackageExport(packageId, bearerToken) {
  const res = await fetch(getPackageExportDetailUrl(packageId), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      Accept: 'application/json',
    },
  })

  return parseJsonResponse(res)
}

/** @deprecated Use getCrashPackageExport */
export const fetchPackageExportById = getCrashPackageExport

/**
 * GET sinistri importati per pacchetto (lazy expand).
 *
 * @param {string} packageId
 * @param {string} bearerToken
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function listCrashPackageExportCrashes(packageId, bearerToken) {
  const res = await fetch(getPackageExportCrashesUrl(packageId), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      Accept: 'application/json',
    },
  })

  return parseJsonResponse(res)
}

/**
 * GET lookup pacchetto per accident/crash id.
 *
 * @param {string} accidentId
 * @param {string} bearerToken
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function getCrashPackageExportByAccidentId(accidentId, bearerToken) {
  const res = await fetch(getPackageExportByAccidentUrl(accidentId), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      Accept: 'application/json',
    },
  })

  return parseJsonResponse(res)
}

/**
 * POST registrazione export (metadati manifest dopo export locale).
 *
 * @param {Record<string, unknown>} payload
 * @param {string} bearerToken
 * @returns {Promise<{ status: number, body: unknown }>}
 */
export async function registerCrashPackageExport(payload, bearerToken) {
  const res = await fetch(getPackageExportsListUrl(), {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  })

  return parseJsonResponse(res)
}

/** @deprecated Use registerCrashPackageExport */
export const postPackageExportRegistration = registerCrashPackageExport
